<template>
  <div style="height: 1966px">
    <div
      style="
        position: absolute;
        left: 0px;
        top: 0px;
        position: absolute;
        background-image: url('/img/event/event_background_mb.png');
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        width: 100%;
        height: 1966px;
      "
    >
      <div
        style="
          position: absolute;
          left: calc(50% - 380px);
          top: 810px;
          width: 80px;
          height: 31px;
          font-family: Poppins;
          font-size: 32px;
          font-weight: 600;
          text-align: center;
          color: #ff7a29;
        "
      >
        {{ numMB }}
      </div>
      <div
        style="
          position: absolute;
          left: calc(50% + 365px);
          top: 810px;
          width: 80px;
            height: 30px;
            font-family: Poppins;
            font-size: 32px;
            font-weight: 600;
            text-align: center;
            color: #ffc500;
}
        "
      >
        {{ remainRoulette }}
      </div>
      <div
        style="
          position: absolute;
          width: 140px;
          height: 40px;
          top: 813px;
          left: calc(50% - 277px);
          cursor: pointer;
          z-index: 600;
        "
        @click="onClickBurn()"
      ></div>
      <div
        style="
          position: absolute;
          top: 1039px;
          width: 100%;
          text-align: center;
          z-index: 200;
        "
      >
        <div
          style="
            position: absolute;
            background-image: url('/img/event/frame.png');
            background-size: 100% 100%;
            width: calc(50vh + 25px);
            height: calc(50vh + 25px);
            padding: 10px;
            margin-left: calc((100% - (50vh + 25px)) / 2);
            z-index: 300;
          "
        >
          <FortuneWheel
            type="image"
            style="width: 100%; height: 100%"
            btnWidth="100%"
            bordercolor="#ffffff"
            v-bind:fontSize="16"
            v-bind:borderWidth="4"
            v-bind:publicKey="publicKey"
            :prizes="prizes"
            @onRotateStartError="onRotateStartError"
            @onRotateStart="onRotateStart"
            @onRotateEnd="onRotateEnd"
          >
            <img slot="wheel" src="/img/event/roulette_mb.png" />
            <img
              slot="button"
              src="/img/event/btn_go.png"
              style="z-index: 1000"
            />
          </FortuneWheel>
          <img
            src="/img/event/arrow.png"
            style="position: absolute; top: -15px; left: calc(50% - 22px)"
          />
        </div>
        <div
          @click="popupHistory()"
          style="
            cursor: pointer;
            position: absolute;
            left: calc(50% - 100px);
            top: calc(50vh + 25px + 80px);
            width: 200px;
            height: 60px;
            border-radius: 4px;
            border: solid 0 #000;
            background-color: #ff7e16;
            padding-top: 13px;
            font-family: Poppins;
            font-size: 20px;
            font-weight: 500;
            text-align: center;
            color: #fff;
          "
        >
          HISTORY
        </div>
      </div>
    </div>
    <div
      style="
        position: fixed;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        background-color: #00000099;
        cursor: pointer;
        z-index: 900;
      "
      v-if="visibleShare || modals.history == true"
      @click="closeAll()"
    >
      <div
        v-if="visibleShare"
        style="
          position: absolute;
          left: 0px;
          top: 0px;
          width: 100%;
          height: 100%;
        "
      >
        <img
          class="rotating"
          src="/img/event/fx.png"
          style="
            position: relative;
            left: calc((100% - 1000px) / 2);
            top: calc((100% - 1000px) / 2);
          "
        />
      </div>
    </div>
    <div
      v-if="visibleShare"
      style="
        position: fixed;
        top: calc((100% - 817px) / 2);
        left: calc((100% - 1020px) / 2);
        padding-top: 30px;
        text-align: center;
        width: 1020px;
        height: 817px;
        background-image: url('/img/event/popup_base.png');
        z-index: 10000;
      "
    >
      <p
        style="
          color: #ffffff;
          font-weight: 900;
          font-size: 32px;
          height: 60px;
          font-family: Poppins;
          position: absolute;
          left: 0px;
          top: 260px;
          width: 100%;
          height: 40px;
          text-align: center;
        "
      >
        {{ prizeName }}
      </p>
      <img
        v-bind:src="`/img/event/${getPrizeImg(selectedId)}`"
        style="position: absolute; left: calc(50% - 100px); top: 360px"
        width="200px"
        height="200px"
      />
      <p
        style="
          position: absolute;
          left: 0px;
          top: 730px;
          width: 100%;
          height: 40px;
          font-weight: 300;
          font-size: 18px;
          height: 100px;
          font-family: Poppins;
          font-size: 32px;
          text-align: center;
          color: #ff7a29;
        "
      >
        * Event prizes will be distributed after the event.
      </p>

      <div
        style="
          position: absolute;
          left: 310px;
          top: 630px;
          width: 400px;
          height: 100px;
          cursor: pointer;
        "
        @click="closeShare()"
      ></div>
    </div>
    <div
      v-if="modals.history"
      style="
        position: fixed;
        top: calc((100% - 837px) / 2);
        left: calc((100% - 1034px) / 2);
        padding-top: 30px;
        text-align: center;
        width: 1034px;
        height: 837px;
        background-image: url('/img/event/history-popup-base.png');
        z-index: 10000;
      "
    >
      <div style="position: absolute; left: 0px; top: 0px; width: 100%">
        <div
          style="
            float: right;
            display: inline-block;
            margin-right: 60px;
            width: 80px;
            height: 80px;
            cursor: pointer;
          "
          @click="closeAll()"
        ></div>
        <div
          style="
            width: 920px;
            height: 612px;
            position: absolute;
            left: calc(50% - 460px);
            top: 146px;
            overflow-y: overlay; 
          "
        >
          <div style="width: 100%; height: 70px">
            <div
              style="
                width: 459px;
                height: 70px;
                margin: 0 1px 1px 0;
                border: solid 0 #000;
                background-color: #101d3c;
                float: left;
                font-family: Poppins;
                font-size: 20px;
                font-weight: 600;
                line-height: 1.8;
                text-align: center;
                color: #ffc200;
                padding-top: 20px;
              "
            >
              TIME
            </div>
            <div
              style="
                width: 459px;
                height: 70px;
                border: solid 0 #000;
                margin: 0 1px 1px 0;
                background-color: #101d3c;
                float: right;
                font-family: Poppins;
                font-size: 20px;
                font-weight: 600;
                line-height: 1.8;
                text-align: center;
                color: #ffc200;
                padding-top: 20px;
              "
            >
              ITEM
            </div>
          </div>
          <div v-for="(log, idx) in mbHisotry"
          :key="idx" style="width: 100%; height: 80px; margin-top: 2px;">
            <div v-if="(idx % 2) == 0"
              style="
                width: 459px;
                height: 80px;
                margin: 0 1px 1px 0;
                border: solid 0 #000;
                background-color: #e9ebf5;
                float: left;
                font-family: Poppins;
                font-size: 24px;
                font-weight: 500;
                line-height: 1.5;
                text-align: center;
                color: #202431;
                padding-top: 23px;
              "
            >
              {{log.logDate | date}}
            </div>              
            <div v-if="(idx % 2) == 0"
              style="
                width: 459px;
                height: 80px;
                border: solid 0 #000;
                background-color: #e9ebf5;
                float: right;
                font-family: Poppins;
                font-size: 24px;
                font-weight: 500;
                line-height: 1.5;
                text-align: center;
                color: #202431;
                padding-top: 23px;
              "
            >
              {{getPrizeName(log.result)}}
            </div>
            <div v-if="(idx % 2) == 1"
              style="
                width: 459px;
                height: 80px;
                margin: 0 1px 1px 0;
                border: solid 0 #000;
                background-color: #fff;
                float: left;
                font-family: Poppins;
                font-size: 24px;
                font-weight: 500;
                line-height: 1.5;
                text-align: center;
                color: #202431;
                padding-top: 23px;
              "
            >
              {{log.logDate | date}}
            </div>
            <div v-if="(idx % 2) == 1"
              style="
                width: 459px;
                height: 80px;
                border: solid 0 #000;
                background-color: #fff;
                float: right;
                font-family: Poppins;
                font-size: 24px;
                font-weight: 500;
                line-height: 1.5;
                text-align: center;
                color: #202431;
                padding-top: 23px;
              "
            >
              {{getPrizeName(log.result)}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="eventEnded"
      style="
        position: fixed;
        width: 80%;
        height: 100px;
        left: 10%;
        top: calc((100% - 100px) / 2);
        background-color: #00000088;
        color: white;
        text-align: center;
        padding-top: 20px;
        font-size: 30px;
        font-weight: 900;
      "
    >
      Thank you. The event has ended.
    </div>
    <div
      v-if="burning"
      style="
        position: fixed;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        line-height: 1000px;
        background-color: #00000088;
        color: white;
        pointer-events: none;
        z-index: 1000000;
      "
    >
      <center>
        <div
          style="
            display: flex;
            justify-content: center;
            margin-top: 200px;
            width: 700px;
            height: 120px;
            line-height: 30px;
            font-size: 16px;
            color: black;
            background-color: white;
            border-radius: 8px;
            text-align: center;
          "
        >
          <br />Burning NFT is in progress. <br />Do not refresh or close the
          window, wait for the transaction to complete.
        </div>
      </center>
    </div>
  </div>
</template>
<script>
import {
  connectWallet,
  getNetwork,
  getNumDragoMysteryBox,
  burnsDragoMysteryBox,
} from "../utils/wallet";
import { Button, FormGroupInput } from "@/components";
import { Popover } from "element-ui";
import FortuneWheel from "../components/FortuneWheel.vue";
import config from "../config.js";
import axios from "axios";
import SocialSharing from "vue-social-sharing";
import moment from "moment";

const gradeColor = ["#A3B7DA", "#167DEF", "#9C1EEE", "#FF6E00"];
function sleep(ms) {
  return new Promise((r) => setTimeout(r, ms));
}
export default {
  name: "event",
  bodyClass: "event-page",
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Popover.name]: Popover,
    FortuneWheel,
    SocialSharing,
  },
  filters: {
    comma(val) {
      return Number(val).toLocaleString("en-US");
      //return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    date(val) {
      if (val) {
        return moment(String(val)).format("YYYY-MM-DD HH:mm:ss");
      }
    },
  },
  watch: {
    "$store.state.account.wallet": async function (val) {
      await this.loadEventInfo();
    },
  },
  methods: {
    async onClickBurn() {
      this.$store.commit(
            "alert",
            "The event has ended."
          );
        return;

      if (this.numMB == 0) {
        this.$store.commit("alert", "No Drago Mystery Box.");
        return;
      }

      let networkId = await getNetwork();
      if (networkId != config.network.polygon) {
        this.$store.commit(
          "alert",
          "Wrong network. You should change network to Polygon mainnet."
        );
        return;
      }

      let self = this;
      self.burning = true;
      burnsDragoMysteryBox(this.$store, this.select_ids)
        .on("transactionHash", async (txHash) => {
          console.log("transactionHash");
          console.log(txHash);
        })
        .on("receipt", async (receipt) => {
          console.log("receipt");
          console.log("publicKey", self.publicKey);
          console.log("transactionHash", receipt.transactionHash);
          await sleep(1000);
          var ret = await axios.post(
            `${config.api.nft_url}/presale/burnsMysteryBox`,
            {
              publicKey: self.publicKey,
              txHash: receipt.transactionHash,
            }
          );
          console.log(ret.data);
          if (ret.data.result) {
            await self.loadEventInfo();
          }
          self.burning = false;
        })
        .on("error", (error) => {
          console.log("error");
          console.log(error);
          self.burning = false;
        });
    },
    onRotateStart(data) {
      this.remainRoulette = data.remainRoullete;
      this.selectedId = data.selectedId;
    },
    onRotateStartError(err) {
      if (err != null && err.code == "event_ended") {
        this.eventEnded = true;
        return;
      }

      if (this.publicKey == "") {
        alert("Connect your wallet to spin roulette.");
        return;
      }

      alert(
        `You don't have enough roulette ticket. You need to burn your Drago Mystery Box.`
      );
    },
    onRotateEnd(prize) {
      //alert(prize.value);
      this.visibleShare = true;
    },
    // onShare() {
    //   console.log("shareNetworkInfo - ", this.shareNetworkInfo);
    //   this.visibleShare = true;
    // },
    closeAll() {
      this.closeShare();
      this.modals.history = false;
    },
    closeShare() {
      this.visibleShare = false;
    },
    async popupHistory() {
      this.closeAll();
      var ret = await axios.post(
        `${config.api.stat_url}/preregist/event/history`,
        {
          publicKey: this.publicKey,
        }
      );
      console.log(ret.data);
      if (ret.data.result) {
        this.mbHisotry = [];
        for (let i = ret.data.history.length - 1; i >= 0; --i) {
          this.mbHisotry.push(ret.data.history[i]);
        }
      } else {
      }
      this.modals.history = true;
    },
    getPrizeName(prizeId) {
      switch (prizeId) {
        case 1:
          return "Land Lv.1";
        case 2:
          return "Land Lv.1";
        case 3:
          return "Normal Drago";
        case 4:
          return "Normal Drago";
        case 5:
          return "Wealthy Mighty Kingdom 1";
        case 6:
          return "Wealthy Mighty Kingdom 2";
        case 7:
          return "Wealthy Mighty Kingdom 3";
        case 8:
          return "The skin pack 1";
        case 9:
          return "Land Lv.6";
        case 10:
          return "Legendary Drago";
      }
      return "";
    },
    getPrizeImg(prizeId) {
      switch (prizeId) {
        case 1:
          return "nft_land_lv1.png";
        case 2:
          return "nft_land_lv1.png";
        case 3:
          return "nft_drago.png";
        case 4:
          return "nft_drago.png";
        case 5:
          return "nft_package_499.png";
        case 6:
          return "nft_package_999.png";
        case 7:
          return "nft_package_1999.png";
        case 8:
          return "nft_skin.png";
        case 9:
          return "nft_land_lv6.png";
        case 10:
          return "nft_legendarydrago.png";
      }
      return "";
    },
    getPrizeColor(prizeId) {
      for (let i = 0; i < this.prizes.length; ++i) {
        if (this.prizes[i].id == prizeId) {
          return this.prizes[i].bgColor;
        }
      }
      return "";
    },
    getGradeColor(grade) {
      return gradeColor[grade - 1];
    },
    async loadEventInfo() {
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        this.publicKey = this.$store.state.account.wallet.address;
      } else {
        this.publicKey = "";
      }
      var ret = await axios.post(
        `${config.api.stat_url}/preregist/event/info`,
        {
          publicKey: this.publicKey,
        }
      );
      console.log(ret.data);
      if (ret.data.result) {
        this.remainRoulette = ret.data.remainRoullete;
      } else {
      }
      this.numMB = await getNumDragoMysteryBox(this.$store);
    },
  },
  computed: {
    prizeName() {
      return this.getPrizeName(this.selectedId);
    },
  },
  mounted: async function () {
    await connectWallet(this.$store);
    await this.loadEventInfo();

    //this.eventEnded = this.$store.state.account.presaleStarted;
    this.eventEnded = false;
  },
  beforeDestroy: function () {},
  data: function () {
    return {
      mbHisotry: [],
      modals: {
        history: false,
      },
      visibleShare: false,
      burning: false,
      publicKey: "",
      eventEnded: false,
      timerId: null,
      tables: [],
      selectedId: 0,
      prizeId: 1,
      remainRoulette: 0,
      numMB: 0,
      numDragoSticker: 0,
      prizes: [
        {
          id: 9,
          name: "Land Lv.6",
          value: "Land Lv.6",
          bgColor: gradeColor[2],
          color: "#ffffff",
          probability: 12.5,
        },
        {
          id: 8,
          name: "The skin pack 1",
          value: "The skin pack 1",
          bgColor: gradeColor[1],
          color: "#ffffff",
          probability: 12.5,
        },
        {
          id: 7,
          name: "Wealthy Mighty Kingdom 3",
          value: "Wealthy Mighty Kingdom 3",
          bgColor: gradeColor[1],
          color: "#ffffff",
          probability: 12.5,
        },
        {
          id: 3,
          name: "Drago",
          value: "Drago",
          bgColor: gradeColor[3],
          color: "#ffffff",
          probability: 12.5,
        },
        {
          id: 1,
          name: "Land Lv.1",
          value: "Land Lv.1",
          bgColor: gradeColor[2],
          color: "#ffffff",
          probability: 12.5,
        },
        {
          id: 10,
          name: "Legendary Drago",
          value: "Legendary Drago",
          bgColor: gradeColor[2],
          color: "#ffffff",
          probability: 12.5,
        },
        {
          id: 6,
          name: "Wealthy Mighty Kingdom 2",
          value: "Wealthy Mighty Kingdom 2",
          bgColor: gradeColor[2],
          color: "#ffffff",
          probability: 12.5,
        },
        {
          id: 5,
          name: "Wealthy Mighty Kingdom 1",
          value: "Wealthy Mighty Kingdom 1",
          bgColor: gradeColor[1],
          color: "#ffffff",
          probability: 12.5,
        },
        {
          id: 4,
          name: "Drago",
          value: "Drago",
          bgColor: gradeColor[0],
          color: "#ffffff",
          probability: 12.5,
        },
        {
          id: 2,
          name: "Land Lv.1",
          value: "Land Lv.1",
          bgColor: gradeColor[3],
          color: "#ffffff",
          probability: 12.5,
        },
      ],
    };
  },
};
</script>
<style>
.scrollbox {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.scrollbox::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}
.tablecss {
  border: 1px solid black !important;
  min-width: 0px !important;
  min-height: 0px !important;
}
.tdcss {
  border: 1px solid black !important;
  min-width: 0px !important;
  min-height: 0px !important;
  max-height: 36px !important;
  height: 36px !important;
}
.thcss {
  border: 1px solid black !important;
  min-width: 0px !important;
  min-height: 0px !important;
  max-height: 28px !important;
  height: 28px !important;
}

input,
textarea:focus {
  outline: none;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
    -o-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
    -o-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}
@-webkit-keyframes rotating {
  from {
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}
.rotating {
  -webkit-animation: rotating 8s linear infinite;
  -moz-animation: rotating 8s linear infinite;
  -ms-animation: rotating 8s linear infinite;
  -o-animation: rotating 8s linear infinite;
  animation: rotating 8s linear infinite;
}
</style>
